import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { FormGrid, NextButton, Notice, OptionAutocomplete } from '../../../../ui';
import actions from '../../../../redux/actions';
import { OperationStatus } from '../../../../types/OperationStatus';
import countryCodes from '../../../../util/options/countryCodes';
import statesUS from '../../../../util/options/statesUS';


const mapStateToProps = (state) => {
    return {
        userSavePhoneStatus: state.userSavePhoneStatus,     //For the Phone save only
        userSaveStatus: state.userSaveStatus,               //After the confirmation ends - the real thing
        user: state.user,
        isMobile: state.resolution.device === 'mobile' || state.resolution.device === 'mobile-tablet',
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateUser: (data) => dispatch(actions.updateUser(data)),   //Just to update local User Model - not going to the server
        requestVerifyPhone: (data) => dispatch(actions.requestVerifyPhone(data)),   // After the 'Next' - see that the phone\user is legit\not taken
        confirmSMS: (data) => dispatch(actions.confirmSMS(data)),           // For the SMS token reply
    };
};

// The phone number and the SMS code are digits only
const digitsOnly = (event) => {
    if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
    }
};

class Personal extends Component<any> {
    public state: any;

    constructor(props) {
        super(props);

        this.state = {
            errors: new Set(),
            token: '',   //Holds the token data
            errorMsg: ''
        };
    }

    componentDidMount() {
        const user = { ...this.props.user };
        if (user.country) {
            const found = countryCodes.find(o => o.value === user.country);
            if (found) {
                const { dialCode } = found;
                user["dialCode"] = dialCode;
                this.props.updateUser(user);
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (
            this.props.userSaveStatus.status !== prevProps.userSaveStatus.status &&
            this.props.userSaveStatus.status === OperationStatus.success
        ) {
            this.props.history.push('/complete-profile/devices');
        }

        if (
            this.props.userSaveStatus.status !== prevProps.userSaveStatus.status &&
            this.props.userSaveStatus.status === OperationStatus.fail
        ) {
            this.setState({ errorMsg: this.props.userSaveStatus.errorMessage });
        }
        if (
            this.props.userSavePhoneStatus.status !== prevProps.userSavePhoneStatus.status &&
            this.props.userSavePhoneStatus.status === OperationStatus.success
        ) {
            this.setState({ errorMsg: '' });
        }
        if (
            this.props.userSavePhoneStatus.status !== prevProps.userSavePhoneStatus.status &&
            this.props.userSavePhoneStatus.status === OperationStatus.fail
        ) {
            this.setState({ errorMsg: this.props.userSavePhoneStatus.errorMessage });
        }
    }

    resetErrorState = (event) => {
        const name = event.target.name;
        const errors = new Set(this.state.errors);

        if (errors.has(name)) {
            errors.delete(name);
            this.setState({ errors });
        }
    };

    onChange = (event, data) => {
        this.resetErrorState(event);
        const user = { ...this.props.user };

        switch (data.name) {
            case 'token': {
                const token = data.value;
                this.setState({ token });
                break;
            }
            case 'country': {
                user[data.name] = data.value;
                const { dialCode } = data.options.find(o => o.value === data.value);
                user["dialCode"] = dialCode;
                if (user.country === 'United States') {
                    user.stateInUS = '';
                }
                break;
            }
            case 'stateInUS': {
                user[data.name] = data.value;
                break;
            }
            default: {
                user[data.name] = data.value;
                break;
            }
        }

        return this.props.updateUser(user);
    };

    validateInput = (event, data) => {
        const errors = new Set(this.state.errors);
        const name = data && data.name ? data.name : event.target.name;
        const value = data && data.value ? data.value : event.target.value;

        if (name === 'age') {
            if (!value.length || parseInt(value) < 0 || !Number(value) || parseInt(value) > 120) {
                errors.add(name);
            } else {
                errors.delete(name);
            }

            this.setState({ errors });
            return;
        }

        if (name == 'token') {
            if (!value.length || parseInt(value) < 0 || !Number(value) || value.length !== 6) {
                errors.add(name);
            } else {
                errors.delete(name);
            }

            this.setState({ errors });
            return;
        }

        if (name == 'phoneNumber') {
            if (!value.length || value.length < 8 || value.length > 15) {
                errors.add(name);
            } else {
                errors.delete(name);
            }

            this.setState({ errors });
            return;
        }

        if (name === 'stateInUS ') {
            if (this.props.user.country === 'United States') {
                if (!value || !value.length) {
                    errors.add(name);
                }
            }
        }

        if (!value || !value.length) {
            errors.add(name);
        } else {
            errors.delete(name);
        }

        this.setState({ errors });
    };

    onNext = () => {
        const userData = { ...this.props.user };
        this.props.requestVerifyPhone(userData);
    }

    onBack = () => {
        window.location.reload();
    }

    onSave = () => {
        this.props.confirmSMS(this.state.token);
    };

    render() {

        const phoneSaving = this.props.userSavePhoneStatus.status === OperationStatus.processing;
        const postPhoneSaved = this.props.userSavePhoneStatus.status === OperationStatus.success;

        const goodToNext = this.props.user.phoneNumber.length > 6;
        const goodToSave = this.state.token.length === 6;

        const userSaveProcessing = this.props.userSaveStatus.status === OperationStatus.processing;
        const user = this.props.user;
        const errors = this.state.errors;

        // Adapters to the (event, { name, value }) handlers above
        const event = (name: string, value: any = '') => ({ target: { name, value } });
        const change = (name: string, value: any, extra: any = {}) => this.onChange(event(name), { name, value, ...extra });
        const focus = (name: string) => () => this.resetErrorState(event(name));
        const blur = (name: string, value: any) => () => this.validateInput(event(name, value ?? ''), { name, value: value ?? '' });

        return (
            <>
                <Notice title="Phone verification">Dear tester, please fill in the required information below to continue, thanks.</Notice>

                <FormGrid isMobile={this.props.isMobile}>
                    <OptionAutocomplete
                        label="Country"
                        required
                        options={countryCodes}
                        value={user.country}
                        error={errors.has('country')}
                        // Clearing the box keeps the last country (the dial code comes from it)
                        onValueChange={(value) => value && change('country', value, { options: countryCodes })}
                        onBlur={blur('country', user.country)}
                        disabled={postPhoneSaved}
                    />
                    {user.country === 'United States' && (
                        <OptionAutocomplete
                            label="State"
                            required
                            options={statesUS}
                            value={user.stateInUS}
                            error={errors.has('stateInUS')}
                            onValueChange={(value) => change('stateInUS', value ?? '')}
                            onBlur={blur('stateInUS', user.stateInUS)}
                            disabled={postPhoneSaved}
                        />
                    )}
                    <TextField
                        name="phoneNumber"
                        label="Phone number"
                        required
                        value={user.phoneNumber}
                        error={errors.has('phoneNumber')}
                        onChange={(e) => change('phoneNumber', e.target.value)}
                        onFocus={focus('phoneNumber')}
                        onBlur={(e) => this.validateInput(e, null)}
                        onKeyPress={digitsOnly}
                        disabled={!user.country || postPhoneSaved}
                        inputProps={{ maxLength: 15, inputMode: 'numeric' }}
                        InputProps={{ startAdornment: user.dialCode ? <InputAdornment position="start">{user.dialCode}</InputAdornment> : undefined }}
                        fullWidth
                    />
                </FormGrid>

                {!postPhoneSaved && (
                    <NextButton
                        label="Next"
                        onClick={this.onNext}
                        busy={phoneSaving}
                        disabled={errors.size > 0 || !goodToNext}
                    />
                )}

                {/* The SMS was sent: ask for the code */}
                {postPhoneSaved && (
                    <>
                        <Box sx={{ maxWidth: 240 }}>
                            <TextField
                                name="token"
                                label="Verification code"
                                placeholder="******"
                                value={this.state.token}
                                error={errors.has('token')}
                                onChange={(e) => change('token', e.target.value)}
                                onFocus={focus('token')}
                                onBlur={(e) => this.validateInput(e, null)}
                                onKeyPress={digitsOnly}
                                inputProps={{ maxLength: 6, inputMode: 'numeric' }}
                                autoFocus
                                fullWidth
                            />
                        </Box>
                        <NextButton
                            label="Verify"
                            onClick={this.onSave}
                            busy={userSaveProcessing}
                            disabled={errors.size > 0 || !goodToSave}
                        />
                    </>
                )}

                {this.state.errorMsg != '' && (
                    <Notice title="Error occured" severity="error">
                        {this.state.errorMsg}
                        {this.state.errorMsg != 'We apologize, but you have made too many attempts. Please try again in 24 hours' && (
                            <Box sx={{ mt: 1 }}>
                                <Button size="small" variant="outlined" color="inherit" startIcon={<ChevronLeftIcon />} onClick={this.onBack}>Back</Button>
                            </Box>
                        )}
                    </Notice>
                )}
            </>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Personal));
